if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        };
        this.mql = window.matchMedia('(min-width: 750px)');
        if (!this.elements.thumbnails) return;

        this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
        this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
  const button = mediaToSwitch.querySelector('button');
  
  // Click to switch
  button.addEventListener('click', () => {
    this.setActiveMedia(mediaToSwitch.dataset.target, false);
  });

  // Hover to switch (desktop only)
  button.addEventListener('mouseenter', () => {
    if (this.mql.matches) { // only on desktop
      this.setActiveMedia(mediaToSwitch.dataset.target, false);
    }
  });
});

        if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();
      }

      onSlideChanged(event) {
        const thumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${event.detail.currentElement.dataset.mediaId}"]`
        );
        this.setActiveThumbnail(thumbnail);
      }

      setActiveMedia(mediaId, prepend) {
        const activeMedia =
          this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`) ||
          this.elements.viewer.querySelector('[data-media-id]');
        if (!activeMedia) {
          return;
        }
        this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
          element.classList.remove('is-active');
        });
        activeMedia?.classList?.add('is-active');

        if (prepend) {
          activeMedia.parentElement.firstChild !== activeMedia && activeMedia.parentElement.prepend(activeMedia);

          if (this.elements.thumbnails) {
            const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
            activeThumbnail.parentElement.firstChild !== activeThumbnail && activeThumbnail.parentElement.prepend(activeThumbnail);
          }

          if (this.elements.viewer.slider) this.elements.viewer.resetPages();
        }

        this.preventStickyHeader();
        window.setTimeout(() => {
          if (!this.mql.matches || this.elements.thumbnails) {
            activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
          }
          const activeMediaRect = activeMedia.getBoundingClientRect();
          // Don't scroll if the image is already in view
          if (activeMediaRect.top > -0.5) return;
          const top = activeMediaRect.top + window.scrollY;
          window.scrollTo({ top: top, behavior: 'smooth' });
        });
        this.playActiveMedia(activeMedia);

        if (!this.elements.thumbnails) return;
        const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
        this.setActiveThumbnail(activeThumbnail);
        this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
      }

     setActiveThumbnail(thumbnail) {
  if (!this.elements.thumbnails || !thumbnail) return;

 
  this.elements.thumbnails.querySelectorAll('button').forEach((btn) => btn.removeAttribute('aria-current'));


  const button = thumbnail.querySelector('button');
  button.setAttribute('aria-current', 'true');


  const slider = this.elements.thumbnails.querySelector('.thumbnail-list') || this.elements.thumbnails;
  const sliderRect = slider.getBoundingClientRect();
  const thumbRect = thumbnail.getBoundingClientRect();

  if (thumbRect.left < sliderRect.left || thumbRect.right > sliderRect.right) {
   
    slider.scrollTo({ left: slider.scrollLeft + (thumbRect.left - sliderRect.left), behavior: 'smooth' });
  }
}


      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector('.product__modal-opener--image img');
        if (!image) return;
        image.onload = () => {
          this.elements.liveRegion.setAttribute('aria-hidden', false);
          this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace('[index]', position);
          setTimeout(() => {
            this.elements.liveRegion.setAttribute('aria-hidden', true);
          }, 2000);
        };
        image.src = image.src;
      }

      playActiveMedia(activeItem) {
        window.pauseAllMedia();
        const deferredMedia = activeItem.querySelector('.deferred-media');
        if (deferredMedia) deferredMedia.loadContent(false);
      }

      preventStickyHeader() {
        this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return;
        this.elements.viewer.slider.setAttribute('role', 'presentation');
        this.elements.viewer.sliderItems.forEach((slide) => slide.setAttribute('role', 'presentation'));
      }
    }
  );
}



const thumbnailSlider = document.querySelector("#GalleryThumbnails-{{ section.id }}");
const prevThumbBtn = thumbnailSlider.querySelector(".slider-button--prev");
const nextThumbBtn = thumbnailSlider.querySelector(".slider-button--next");
const thumbs = thumbnailSlider.querySelectorAll(".thumbnail-list__item");

let thumbIndex = 0;

const updateThumbPosition = () => {
  thumbs.forEach((thumb, idx) => {
    thumb.classList.toggle("is-visible", idx === thumbIndex);
  });
};

prevThumbBtn?.addEventListener("click", () => {
  thumbIndex = (thumbIndex - 1 + thumbs.length) % thumbs.length;
  updateThumbPosition();
});

nextThumbBtn?.addEventListener("click", () => {
  thumbIndex = (thumbIndex + 1) % thumbs.length;
  updateThumbPosition();
});


document.addEventListener("DOMContentLoaded", () => {
  const gallery = document.querySelector("#GalleryViewer-{{ section.id }}");
  if (!gallery) return;

  let startX = 0;
  let isDragging = false;

  const getSlider = () => gallery.slider; // Shopify slider object

  gallery.addEventListener("touchstart", (e) => {
    startX = e.touches[0].clientX;
    isDragging = true;
  }, { passive: true });

  gallery.addEventListener("touchmove", (e) => {
    if (!isDragging) return;
    e.preventDefault(); // prevent page scrolling while swiping
  }, { passive: false });

  gallery.addEventListener("touchend", (e) => {
    if (!isDragging) return;
    const diff = e.changedTouches[0].clientX - startX;
    const slider = getSlider();
    if (!slider) return;

    if (diff < -30) {
      slider.nextSlide();
    } else if (diff > 30) {
      slider.previousSlide();
    }
    isDragging = false;
  });

  gallery.addEventListener("touchcancel", () => {
    isDragging = false;
  });
});
